/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NoticeDto } from '../../models/notice-dto';

export interface NoticeControllerDelete$Params {
  id: string;
}

export function noticeControllerDelete(http: HttpClient, rootUrl: string, params: NoticeControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
  const rb = new RequestBuilder(rootUrl, noticeControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NoticeDto>;
    })
  );
}

noticeControllerDelete.PATH = '/api/notices/{id}';
